import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { MainComponent } from 'src/app/components/main/main.component';

import { JqWidgets } from 'src/app/utils/jqWidgets';

import { AdministradorService } from 'src/app/services/administrador/administrador.service';

import { TareaModel } from 'src/app/services/administrador/models/tarea.model';

import { ListadoTareasComponent } from '../listado-tareas/listado-tareas.component';
import { WindowComponent } from 'projects/movisat-common-gui/src/public-api';


@Component({
  selector: 'app-edit-tarea',
  templateUrl: './edit-tarea.component.html',
  styleUrls: ['./edit-tarea.component.css']
})
export class EditTareaComponent {
  @ViewChild('formWindow') protected formWindow: WindowComponent;

  protected actions = [
    {type: "button", action:"save", value: "", label: this.translate('Guardar')},
    {type: "button", action:"cancel", value: "", label: this.translate('CANCELAR')}
  ];

  public actionButtonClicked(event): void {
    if(event.action === 'save') {
      this.onGuardar();
      return;
    }

    if(event.action === 'cancel') {
      this.onClose()
      return;
    }
  }

  private componentRef = null;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public tarea: TareaModel;

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private administradorService: AdministradorService,
    private ref: ChangeDetectorRef,
  ) {
  }

  init(componentRef: any, tarea: TareaModel){
    this.componentRef = componentRef;
    this.tarea = tarea;

    this.ref.detectChanges();
  }

  onClose() {
    if(this.componentRef) {
      this.componentRef.destroy();
      ListadoTareasComponent._this.window.expandWindow();
    }
  }

  setActivado(event: any){
    if(event.args.checked){
      this.tarea.activado = true;
    }else {
      this.tarea.activado = false;
    }
  }

  async onGuardar(){
    let tarea = await this.administradorService.updateTarea(this.tarea);
    if(tarea !== null) {
      this.tarea = tarea;

      let index = ListadoTareasComponent._this.jobsList.findIndex(job => job.id === this.tarea.id);
      ListadoTareasComponent._this.jobsList[index] = this.tarea;

      this.onClose();
      MainComponent.getInstance().showInfo(
        'ATENCION',
        'Registro_almacenado',
        2000
      );
    }else{
      MainComponent.getInstance().showError(
        'ATENCION',
        'Fallo_almacenar_info',
        2000
      );
    }
  }
}
